import { render, staticRenderFns } from "./multiple-choice.vue?vue&type=template&id=b2850e80&scoped=true"
import script from "./multiple-choice.ts?vue&type=script&lang=ts&external"
export * from "./multiple-choice.ts?vue&type=script&lang=ts&external"
import style0 from "./multiple-choice.scss?vue&type=style&index=0&id=b2850e80&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2850e80",
  null
  
)

export default component.exports